import { BaseApi } from "../base";

export default class BillingApi extends BaseApi {
  protected readonly service = "rest-api";
  protected readonly prefix = "billing";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = () => this.get("");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCoupon = () => this.get("coupons");

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (token: string) =>
    this.post("token", {
      token_id: token,
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateBillingAddress = (billingAddress: string) => this.patch("", { emails: [billingAddress] });
}
